module.exports = __webpack_public_path__ + "src/assets/sounds/sand_full_sound.mp3";